import * as angular from "angular";
import {IController, IScope, ITimeoutService} from "angular";
import * as _ from "lodash";
import {LogisticsVehicle} from "../../../logistics-vehicle/models/logistics-vehicle.model";
import {LocationHolderType} from "../../../commons/types/locationHolder.type";
import {LocationService} from "../../../commons/services/location-service.service";
import {$agentFactory} from "../../$agent.factory";
import {$agentsFactory} from "../../$agents.factory";
import {SplitService} from "../../../commons/services/split-service.service";
import {$bringozLocationsFactory} from "../../../commons/$bringozLocations.factory";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {LocationModel} from "../../../commons/models/location.model";
import {LocationsFacadeService} from "../../../commons/angular/services/locations/locations-facade.service";
import {Subscription} from "rxjs";
import {
  AgentConfigurationProfilesRequestsService
} from "../../../configuration-profiles/services/agent-configuration-profiles-requests.service";

export class AgentsItinerariesListViewCtrl implements IController {

  agentsGroup: any;
  branchIds: any;
  agentSkills: any;
  tags?: string[];
  teamIds?: string[];
  queryString: any;
  agentIds: string[];

  private agentRef: any;
  private agentsRef: any;

  public isSmallScreen: boolean;
  public isMobile: boolean;
  private SITE_ID: any;
  private highlightedTaskId: any;
  private selectedAgent: any;
  private agentLocation: any;
  private agents: any;
  private showMapOnSmallScreen: boolean;
  private logisticsVehiclesRef: any;
  private logisticsVehicleLocationRef: any;
  private hasLogisticsVehiclePermission: boolean;
  public logisticsVehicles: LogisticsVehicle[];
  private pushesTimeoutRef: any;
  private maxUserIdleTimeMinutes: number;
  private selectLocationsSubscription: Subscription;
  public agentConfigurationProfile: any;

  constructor(private $agent: $agentFactory, private $agents: $agentsFactory, private $state, private $stateParams, private moment, private $mdMedia,
              private $logisticsVehicleLocation, private $logisticsVehicle, private locationService: LocationService, private commonsService: CommonsService,
              private resizeService: ResizeService, private $log, private $timeout: ITimeoutService, private $bringozLocations: $bringozLocationsFactory,
              private commonsDialogService: CommonsDialogService, private agentConfigurationProfilesRequestsService: AgentConfigurationProfilesRequestsService,
              private splitService: SplitService, private $scope: IScope, private IAMPermissions, private locationsFacadeService: LocationsFacadeService) {
    this.logisticsVehiclesRef = this.$logisticsVehicle();
    this.logisticsVehicleLocationRef = this.$logisticsVehicleLocation();
    this.hasLogisticsVehiclePermission = this.IAMPermissions.hasPermission('vehicleInstance.logisticsVehicle.list');
    this.maxUserIdleTimeMinutes = this.splitService.maxUserIdleTimeMinutes();
  }

  $onInit() {
    this.SITE_ID = this.splitService.getSiteId();
    this.showMapOnSmallScreen = false;

    this.agentRef = null;
    this.agentsRef = this.$agents();
    this.agents = [];

    if (!this.branchIds) {
      this.branchIds = []
    }

    if (this.$stateParams.agentId) {
      this.bindAgent(this.$stateParams.agentId);
      this.getAgentConfigurationProfile(this.$stateParams.agentId);
    } else {
      this._bindAgentsByGroup(this.agentsGroup);
      if (!!this.hasLogisticsVehiclePermission) {
        this._initLogisticsVehicles();
      }
    }

    // Agents/Logistics Vehicles Location Change Event Listener
    this.locationsFacadeService.subscribeToChannels();
    this._initLocationSubscription();

    // Bind User Event Listeners
    this.commonsService.bindUserEvents((event) => {
      if (!!this.pushesTimeoutRef) {
        this._initPushesTimer();
      }
    })

    this._initPushesTimer();
  }

  $onChanges(changes) {
    if ((changes.agentsGroup && !changes.agentsGroup.isFirstChange()) ||
      (changes.branchIds && !changes.branchIds.isFirstChange()) ||
      (changes.agentSkills && !changes.agentSkills.isFirstChange()) ||
      (changes.tags && !changes.tags.isFirstChange()) ||
      (changes.teamIds && !changes.teamIds.isFirstChange()) ||
      (changes.agentIds && !changes.agentIds.isFirstChange()) ||
      (changes.queryString && !changes.queryString.isFirstChange())) {
      this._bindAgentsByGroup(this.agentsGroup);
    }
    if (changes.branchIds && !changes.branchIds.isFirstChange()) {
      if (!!this.hasLogisticsVehiclePermission) {
        this._initLogisticsVehicles();
      }
    }
  }

  $onDestroy() {
    this.locationsFacadeService.removeAllLocations();
    this.selectLocationsSubscription.unsubscribe();
    this._destroyPushesTimer();
  }

  $doCheck() {
    this.isSmallScreen = !this.$mdMedia('gt-md');
    this.isMobile = this.$mdMedia('xs');
  }

  // ******************************
  //       Responsive Views
  // ******************************

  onBackSmallScreen() {
    this.showMapOnSmallScreen = false;
    this.$timeout(0).then(() => {
      this.resizeService.resize();
    })
  };

  onToggleMap() {
    this.showMapOnSmallScreen = !this.showMapOnSmallScreen;
    this.$timeout(0).then(() => {
      this.resizeService.resize();
    })
  };

  onBranchIdsChange(branchIds) {
    this.branchIds = branchIds;
    this._bindAgentsByGroup(this.agentsGroup);
  }

  onAgentSelect(agent) { // can be also agentId

    if (!agent) {
      return;
    }


    let agentId = _.get(agent, 'id') || agent;

    this.locationsFacadeService.removeAllLocations();

    this.$state.go('.', {agentId: agentId}, {notify: false, reload: false});

    this.bindAgent(agentId);
    this.getAgentConfigurationProfile(agentId);
  }


  onBackToList() {

    this.$timeout(1000).then(() => {
      this._initLocationSubscription();
      this._initPushesTimer();
    })

    this.onAgentsGroupChange(this.agentsGroup);
    this.$state.go('.', {agentId: undefined}, {notify: false, reload: false});
  }

  onAgentsGroupChange(agentsGroup) {
    this.agentsGroup = agentsGroup;
    this.splitService.setSiteItinerarySettings({agentsGroup: agentsGroup});
    this._unBindSelectedAgent();
    this._bindAgentsByGroup(agentsGroup);
    this.$timeout(0).then(() => {
      this.resizeService.resize();
    })

    if (!!this.hasLogisticsVehiclePermission) {
      this._initLogisticsVehicles();
    }
  }

  // ******************************
  //        Internal methods
  // ******************************

  bindAgent(selectedAgentId) {

    if (this.agentRef) {
      this.agentRef.$destroy();
      this.agentRef = undefined;
    }

    if (selectedAgentId) {
      this.agentRef = this.$agent(selectedAgentId);
      this.agentRef.$bindCtrl(this.$scope, this, 'selectedAgent');
    } else {
      this.selectedAgent = null;
      this.agentLocation = null;
    }

    this.$timeout(() => {
    }, 0);

  }

  private getAgentConfigurationProfile(agentId) {
    this.agentConfigurationProfile = undefined;
    this.agentConfigurationProfilesRequestsService.getConfigurationByAgent(agentId)
      .then((agentConfigProfile) => {
        this.agentConfigurationProfile = agentConfigProfile;
      })
  }

  private _initLocationSubscription() {
    // Agents/Logistics Vehicles Location Change Event Listener
    // this.locationsRef.$subscribeToChannelEvents((updatedLocations, action) => {
    //   _.forEach(updatedLocations, (updatedLocation) => {
    //
    //     if (updatedLocation.holder === LocationHolderType.Agent) {
    //
    //       if (_.get(this.selectedAgent, 'id') === _.get(updatedLocation, 'holderId')) {
    //         const agentCopy = angular.copy(this.selectedAgent);
    //         agentCopy.lastKnownLocation = updatedLocation;
    //         this.selectedAgent = agentCopy;
    //       }
    //
    //       const agentIndex = _.findIndex(this.agents,(a: any) => {
    //         return a.id === updatedLocation.holderId
    //       });
    //       if (agentIndex > -1) {
    //         const agentsCopy = angular.copy(this.agents);
    //         agentsCopy[agentIndex].lastKnownLocation.coordinates = updatedLocation.coordinates;
    //
    //         this.agents = agentsCopy;
    //       }
    //     }
    //
    //     if (updatedLocation.holder === LocationHolderType.LogisticsVehicle) {
    //       const logisticsVehicleIndex = _.findIndex(this.logisticsVehicles,(l) => {
    //         return l.id === updatedLocation.holderId
    //       });
    //       if (logisticsVehicleIndex > -1) {
    //         const logisticsVehiclesCopy = angular.copy(this.logisticsVehicles);
    //         logisticsVehiclesCopy[logisticsVehicleIndex].coordinates = updatedLocation.coordinates;
    //
    //         this.logisticsVehicles = logisticsVehiclesCopy;
    //       }
    //     }
    //   })
    // });


    this.selectLocationsSubscription = this.locationsFacadeService.selectLocations()
      .subscribe((locations) => {
        _.forEach(locations, (updatedLocation: LocationModel) => {


          if (updatedLocation.holder === LocationHolderType.Agent) {

            if (_.get(this.selectedAgent, 'id') === _.get(updatedLocation, 'holderId')) {
              const agentCopy = angular.copy(this.selectedAgent);
              agentCopy.lastKnownLocation = updatedLocation;
              this.selectedAgent = agentCopy;
              this.$timeout(() => {
              }, 0);
            }

            const agentIndex = _.findIndex(this.agents, (a: any) => {
              return a.id === updatedLocation.holderId
            });
            if (agentIndex > -1) {

              if (this.agents[agentIndex].lastKnownLocation.updatedAt < updatedLocation.updatedAt) {

                const agentsCopy = angular.copy(this.agents);
                agentsCopy[agentIndex].lastKnownLocation.coordinates = updatedLocation.coordinates;

                this.agents = agentsCopy;
              }
            }
          }

          if (updatedLocation.holder === LocationHolderType.LogisticsVehicle) {
            const logisticsVehicleIndex = _.findIndex(this.logisticsVehicles, (l) => {
              return l.id === updatedLocation.holderId
            });
            if (logisticsVehicleIndex > -1) {

              if (!this.logisticsVehicles[logisticsVehicleIndex].coordinates ||
                this.logisticsVehicles[logisticsVehicleIndex].coordinates.latitude != updatedLocation.coordinates.latitude ||
                this.logisticsVehicles[logisticsVehicleIndex].coordinates.longitude != updatedLocation.coordinates.longitude) {
                const logisticsVehiclesCopy = angular.copy(this.logisticsVehicles);

                logisticsVehiclesCopy[logisticsVehicleIndex].coordinates = updatedLocation.coordinates;

                this.logisticsVehicles = logisticsVehiclesCopy;
              }
            }
          }
        })

        // Update Angularjs Cycle
        this.$timeout(0).then(() => {
        });
      })

  }

  private _bindAgentsByGroup(agentsGroup) {

    if (!!this.agents?.length) {
      this.locationsFacadeService.removeLocationsByIds(this.agents.map(a => a.id));
    }

    this.agents = [];

    // this.bringozLoaderService.on();
    this.getAgentIdsByQuery(agentsGroup)
      .then((agentIds) => {
        return this.agentsRef.$asyncValues(agentIds);
      })
      .then((agents) => {
        if (this.agentsGroup === agentsGroup) {
          this.agents = agents;
          this._getAgentsLocations(_.map(agents, 'id'));
        }
      })
      .catch((error) => {
        this.$log.error('Failed to get agents @deliveriesMapView@getAgentIdsByQuery', error)
      })
  }

  private getAgentIdsByQuery(agentsGroup) {

    const queryPayload = {
      query: this.queryString,
      status: undefined,
      group: undefined,
      sortByLoad: true,
      branchIds: this.branchIds || [],
      ids: this.agentIds || [],
      teamIds: this.teamIds || [],
      skill: this.agentSkills,
      tags: this.tags,
      active: true
    };

    if (!!agentsGroup) {
      if (_.isEqual(agentsGroup, 'Active')) {
        queryPayload.group = agentsGroup;
      }
      if (_.isEqual(agentsGroup, 'OffDuty')) {
        queryPayload.status = agentsGroup;
      }
    }

    return this.agentsRef.$getAll(queryPayload);
  }

  private _unBindSelectedAgent() {
    if (this.agentRef) {
      this.agentRef.$destroy();
    }

    this.selectedAgent = null;
    this.agentLocation = null;
    this.$timeout(() => {
    }, 0);
  }

  private _initLogisticsVehicles() {
    if (!!this.logisticsVehicles?.length) {
      this.locationsFacadeService.removeLocationsByIds(this.logisticsVehicles.map(logisticVehicle => logisticVehicle.id));
    }

    this.logisticsVehicles = [];

    this.logisticsVehiclesRef.$getAll({limit: 250, branchIds: this.branchIds})
      .then((logisticsVehiclesIds: string[]) => {
        return this.logisticsVehiclesRef.$asyncValues(logisticsVehiclesIds)
      })
      .then((logisticsVehicles: LogisticsVehicle[]) => {
        if (logisticsVehicles.length) {
          this.logisticsVehicles = logisticsVehicles;

          this._setLogisticsVehiclesLocations(_.map(logisticsVehicles, 'id'));
        }
      })
  }

  private _getAgentsLocations(agentIds) {
    const payload = _.map(agentIds, (id) => {
      return {
        holderId: id,
        holder: LocationHolderType.Agent
      }
    })

    this.locationsFacadeService.getLocations(payload);
  }

  private _setLogisticsVehiclesLocations(ids: string[]) {
    const payload = _.map(ids, (id) => {
      return {
        holderId: id,
        holder: LocationHolderType.LogisticsVehicle
      }
    });

    this.locationsFacadeService.getLocations(payload);
  }

  private _initPushesTimer() {
    this._destroyPushesTimer();

    this.pushesTimeoutRef = this.$timeout(() => {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;

      this.commonsDialogService.stillThereConfirm()
        .then((continueSession) => {
          if (continueSession) {
            this._initPushesTimer();

            //Sync Agents Locations
            // this._getAgentsLocations(_.map(this.agents, 'id'));
            //
            // //Sync Logistics Vehicles Locations
            // this._setLogisticsVehiclesLocations(_.map(this.logisticsVehicles, 'id'));
          }
        })
    }, (this.maxUserIdleTimeMinutes * 60000));
  }

  private _destroyPushesTimer() {
    if (this.pushesTimeoutRef) {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;
    }
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentsItinerariesListView', {
    bindings: {
      agentsGroup: '<',
      branchIds: '<?',
      agentSkills: '<?',
      tags: '<?',
      teamIds: '<?',
      queryString: '<?',
      agentIds: '<'
    },
    template: require('./agents-itineraries-list-view.html').default,
    controller: AgentsItinerariesListViewCtrl
  });
